import { z } from 'zod'
import { indicatorSchema } from '../helper'
import { logicalOperatorEnum, TLogicalOperator } from './TLogicalOperators'
import { mathSymbolEnum, TMathSymbol } from './TMathSymbols'

export const alertRuleConditionSchema = z.object({
  id: z.string(),
  indicatorCode: z.string().nullable(),
  indicator: indicatorSchema.nullable(),
  value: z.number().nullable(),
  mathSymbol: z.string().nullable(),
  logicalOperator: z.string().nullable(),
  position: z.number().optional(),
})

export type TAlertRuleCondition = z.infer<typeof alertRuleConditionSchema>

export const createAlertRuleConditionSchema = z.object({
  indicator: z.string().min(1, 'alert.selectIndicator'),
  value: z.number().optional(),
  mathSymbol: mathSymbolEnum.optional(),
  logicalOperator: logicalOperatorEnum.optional(),
})

export type TCreateAlertRuleConditionFields = z.infer<
  typeof createAlertRuleConditionSchema
>

export const alertRuleDefinitionItemSchema: z.ZodType<any> = z.lazy(() =>
  z.object({
    id: z.string().nullable().optional(),
    type: z.enum(['condition', 'group']),
    position: z.number(),
    logicalOperatorBefore: logicalOperatorEnum.nullable().optional(),
    indicator: z.string().nullable().optional(),
    indicatorCode: z.string().nullable().optional(),
    value: z.number().nullable().optional(),
    mathSymbol: mathSymbolEnum.nullable().optional(),
    items: z.array(alertRuleDefinitionItemSchema).optional().default([]),
  }),
)

export type TAlertRuleDefinitionItem = {
  id?: string | null
  type: 'condition' | 'group'
  position: number
  logicalOperatorBefore?: TLogicalOperator | null
  indicator?: any
  indicatorCode?: string | null
  value?: number | null
  mathSymbol?: TMathSymbol | null
  items?: TAlertRuleDefinitionItem[]
}

export type TAlertRuleDefinition = {
  items: TAlertRuleDefinitionItem[]
}
